const startsLowercase = (text: string) => /^[a-zà-öø-ÿ]/u.test(text);
const endsSentence = (text: string) => /[.!?…:;]["'”’)]*$/u.test(text);

export const normalizeBlogHtml = (html: string) => {
  const document = new DOMParser().parseFromString(html, 'text/html');

  document.body.querySelectorAll<HTMLAnchorElement>('a[href^="https://luis-brunello-site.vercel.app/"]').forEach(link => {
    const path = new URL(link.href).pathname;
    link.href = path === '/blog/mamoplastia-de-aumento-o-que-saber-antes'
      ? '/procedimentos/mamoplastia-de-aumento'
      : path;
    link.removeAttribute('target');
    link.removeAttribute('rel');
  });

  document.body.querySelectorAll('h1').forEach(heading => {
    const replacement = document.createElement('h2');
    for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
    while (heading.firstChild) replacement.append(heading.firstChild);
    heading.replaceWith(replacement);
  });

  document.body.querySelectorAll('p').forEach(paragraph => {
    const text = paragraph.textContent?.replace(/\u00a0/g, ' ').trim();
    if (!text && !paragraph.querySelector('img, video, iframe')) paragraph.remove();
  });

  let paragraph = document.body.firstElementChild;
  while (paragraph) {
    const next = paragraph.nextElementSibling;
    const left = paragraph.textContent?.trim() || '';
    const right = next?.textContent?.trim() || '';

    if (
      paragraph.tagName === 'P' &&
      next?.tagName === 'P' &&
      left &&
      startsLowercase(right) &&
      !endsSentence(left)
    ) {
      paragraph.append(document.createTextNode(' '));
      while (next.firstChild) paragraph.append(next.firstChild);
      next.remove();
      continue;
    }

    paragraph = next;
  }

  return document.body.innerHTML;
};
